export class DateHelper {
    public getTimeSinceDate(date: Date): string {
        const now = new Date();
        const timeDifferenceInMilliSeconds = (now.getTime() - date.getTime());
        const timeDifferenceInSeconds = Math.floor(timeDifferenceInMilliSeconds / 1000);

        const secondsInOneMinute = 60;
        const secondsInOneHour = secondsInOneMinute * 60;
        const secondsInOneDay = secondsInOneHour * 24;

        if(timeDifferenceInSeconds > secondsInOneDay) {
            const numberOfDays = Math.floor(timeDifferenceInSeconds / secondsInOneDay);
            if(numberOfDays === 1) {
                if(now.getDate() === date.getDate()) return "today";
                return "yesterday";
            } 
            return `${numberOfDays} days ago`;
        } else if (timeDifferenceInSeconds > secondsInOneHour) {
            return `${Math.floor(timeDifferenceInSeconds / secondsInOneHour)} hours ago`;
        } else if (timeDifferenceInSeconds > secondsInOneMinute) {
            return `${Math.floor(timeDifferenceInSeconds / secondsInOneMinute)} minutes ago`;
        }
        
        return "1 minute ago";
    }

    public getFormattedDate(date: Date): string {
        let formattedDate = "N/A";
        if (date) {
            date = new Date(date);
            formattedDate = `${this.getFormattedDayOrMonth(date.getDate())}-${this.getFormattedDayOrMonth((date.getMonth() + 1))}-${date.getFullYear()}`;
        }
        return formattedDate;
    }

    private getFormattedDayOrMonth(dayOrMonth: number): string {
        if (!dayOrMonth) return "N/A";

        if (dayOrMonth.toString().length === 1) {
            return `0${dayOrMonth}`;
        }

        return dayOrMonth.toString();
    }   
}

export const DateHelperSingleton = new DateHelper();